// extracted by mini-css-extract-plugin
export var closed = "Drawer-module--closed--me9U2";
export var drawer = "Drawer-module--drawer--X07ex";
export var shadow = "Drawer-module--shadow--YStQ7";